export class CookieServant {
  /**
   * find the value of a key in the cookie string
   * @param cookieKey
   */
  static getCookie(cookieKey: string): string {
    return decodeURIComponent(document.cookie.replace(this.cookieRegex(cookieKey), '$1')) || '';
  }

  static cookieRegex(key: string) {
    return new RegExp(
      '(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'
    );
  }
}
